import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FadeIn, Section, SectionTitle, Accent, pad2 } from './Shared';
import { Stars } from './HeaderSections';
import { OfferCard } from './CoreSections';
import { useCountdown } from '../hooks/useCountdown';
import { coachTestimonials } from '../data/testimonials';
import { faqs } from '../data/faqs';
import { ShieldCheck, Plus, Clock, Lock, CreditCard, ArrowRightIcon, MailIcon, AtSignIcon, MapPinIcon } from 'lucide-react';
export const Testimonials2 = () => <Section className="bg-slate-950" data-id="element-172" data-mp="13a4spyr151rp">
    <FadeIn data-id="element-173" data-mp="pgvpkftodchm">
      <SectionTitle sub={<span className="inline-flex flex-wrap items-center justify-center gap-2" data-id="element-175" data-mp="pgdieo5h5dux">
            <Stars size={14} data-id="element-176" data-mp="tgw9uh3gghwl" />
            <span className="font-semibold text-white" data-id="element-177" data-mp="tfuonjsq6f15">4.9/5</span>
            <span data-id="element-178" data-mp="1h70623ebdfdk">· +150 trainers across the Americas</span>
          </span>} data-id="element-174" data-mp="phf4dno13krf">
        What <Accent data-id="element-179" data-mp="1lzbexvr18bi9">coaches</Accent> are saying
      </SectionTitle>
    </FadeIn>

    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4" data-id="element-180" data-mp="31lw7y74pnzas">
      {coachTestimonials.map((t, i) => <FadeIn key={t.name} delay={Math.min(i * 0.05, 0.2)} data-id="element-181" data-mp="2wovydm8nkeex" data-mpi={i}>
          <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-5" data-id="element-182" data-mp="3bc7dfy41mgjs">
            <Stars data-id="element-183" data-mp="36l8roj0acq95" />
            <blockquote className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-184" data-mp="36kpiprsm5c79">
              “{t.text}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-185" data-mp="3kf8evlhyrjh4">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${t.bg} text-xs font-bold text-white`} data-id="element-186" data-mp="3gb0prn7lg1id">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-187" data-mp="3pda12faorywt">
                <p className="text-sm font-semibold leading-tight text-white" data-id="element-188" data-mp="3pa5l6knuzeqb">{t.name}</p>
                <p className="flex items-center gap-1 text-xs text-slate-500" data-id="element-189" data-mp="1zxk85u2b929o">
                  <MapPinIcon size={11} aria-hidden="true" data-id="element-190" data-mp="1uzipha8sr4yq" /> {t.location} · Verified purchase
                </p>
              </div>
            </figcaption>
          </figure>
        </FadeIn>)}
    </div>
  </Section>;
export const Guarantee = () => <Section className="bg-slate-900/40" data-id="element-191" data-mp="7w0rnu86cq77">
    <FadeIn className="mx-auto grid max-w-4xl items-center gap-8 rounded-3xl border border-emerald-500/25 bg-emerald-500/[0.05] p-6 md:grid-cols-[auto_1fr] md:gap-12 md:p-12" data-id="element-192" data-mp="7uzjpymggjtp">
      <div className="mx-auto flex h-28 w-28 items-center justify-center rounded-full border border-emerald-500/30 bg-emerald-500/10 md:h-36 md:w-36" data-id="element-193" data-mp="huqbhsjmskq3">
        <div className="text-center" data-id="element-194" data-mp="mqx7otm86huu">
          <ShieldCheck size={36} className="mx-auto text-emerald-400" aria-hidden="true" data-id="element-195" data-mp="rj8b46g6cls5" />
          <p className="mt-1 font-display text-2xl font-black italic leading-none text-white md:text-3xl" data-id="element-196" data-mp="vl3hvqgvjrdb">7 days</p>
        </div>
      </div>
      <div className="text-center md:text-left" data-id="element-197" data-mp="10lznc8gvjlku">
        <h2 className="font-display text-3xl font-black uppercase italic leading-[0.95] tracking-tight text-white md:text-5xl" data-id="element-198" data-mp="15j9lqdm8r7kt">
          7-day guarantee — <span className="text-emerald-400" data-id="element-199" data-mp="1fo9a5x3he0pz">no questions asked</span>
        </h2>
        <div className="mt-5 space-y-3 text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-200" data-mp="1anbp9cr36sks">
          <p data-id="element-201" data-mp="15oidppvd1bn9">Open the volumes. Use them in your classes.</p>
          <p className="text-lg font-semibold leading-snug text-white md:text-xl" data-id="element-202" data-mp="15r3d8886rfhu">
            If within 7 days it's not what you expected: 100% refund.
          </p>
          <p data-id="element-203" data-mp="1ydfvlrvnt6fh">No forms. No hassle. No runaround.</p>
        </div>
        <p className="mt-5 text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-204" data-mp="1tekzxpclfndy">
          Refund rate: under 2%
        </p>
      </div>
    </FadeIn>
  </Section>;
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-slate-950" data-id="element-205" data-mp="2h4ff4dkdxo1d">
      <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-206" data-mp="2h5gwt0vwp8s2">
        <FadeIn className="text-center lg:text-left" data-id="element-207" data-mp="2cd70n3477chc">
          <h2 className="font-display text-4xl font-black uppercase italic leading-[0.92] tracking-tight text-white md:text-6xl" data-id="element-208" data-mp="2cbm79gtmdzl2">
            Frequently asked <Accent data-id="element-209" data-mp="21vbp3aana5dk">questions</Accent>
          </h2>
          <p className="mt-4 text-slate-400" data-id="element-210" data-mp="21spet2wddbrn">
            Still unsure? Write to us at{' '}
            <a href="mailto:soportecentershop95@gmail.com" className="font-medium text-sky-400 underline-offset-4 hover:underline" data-id="element-211" data-mp="1nwu25eskcwwp">
              soportecentershop95@gmail.com
            </a>
          </p>
        </FadeIn>
        <FadeIn delay={0.05} data-id="element-212" data-mp="2fojhh46jv4wb">
          <div className="divide-y divide-white/10 border-y border-white/10" data-id="element-213" data-mp="2kljkt7c0ltjq">
            {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return <div key={faq.q} data-id="element-214" data-mp="2av8drbx1b48m" data-mpi={i}>
                  <h3 data-id="element-215" data-mp="2au5plbr3jfwe">
                    <button id={`faq-q-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 rounded-md" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-a-${i}`} data-id="element-216" data-mp="2atnj7mapzlar">
                      <span className="text-base font-semibold text-white md:text-lg" data-id="element-217" data-mp="11mc8zt2u672f">{faq.q}</span>
                      <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-blue-600 text-white' : 'bg-white/5 text-slate-300'}`} aria-hidden="true" data-id="element-218" data-mp="wnslvpciap8h">
                        <Plus size={16} data-id="element-219" data-mp="40oejdpxxytj" />
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-220" data-mp="itrlys9tiw6j">
                    {isOpen && <motion.div id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-221" data-mp="dz40l2a42hw6">
                        <p className="pb-5 pr-12 text-[15px] leading-relaxed text-slate-300 md:text-base" data-id="element-222" data-mp="26bprpfj9nthc">
                          {faq.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: '3 hrs a week searching for sessions',
    costo: '156 hrs a year'
  }, {
    sin: 'Classes with no structure',
    costo: 'Members who quit'
  }, {
    sin: 'No adaptations by level',
    costo: "New members don't come back"
  }, {
    sin: 'No yearly program',
    costo: 'The same old circuits'
  }, {
    sin: 'Sundays scrolling for ideas',
    costo: 'The same cycle every year'
  }];
  return <Section className="bg-slate-900/40" data-id="element-223" data-mp="396fxri1ck6nd">
      <FadeIn className="mx-auto max-w-3xl" data-id="element-224" data-mp="397hkijrq6hkx">
        <SectionTitle data-id="element-225" data-mp="3473boziav3lu">
          What does it cost you
          <br data-id="element-226" data-mp="345igd7o5vgmx" /> <Accent data-id="element-227" data-mp="345igr8s2ping">not to have it?</Accent>
        </SectionTitle>

        <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03]" data-id="element-228" data-mp="2z8s1uos08t3m">
        <table className="w-full text-left" data-id="element-229" data-mp="2u9fi4cwfk259">
          <thead data-id="element-230" data-mp="2ua6zojt6zzcj">
            <tr className="border-b border-white/10 bg-white/[0.04]" data-id="element-231" data-mp="2uaqkc8a891u9">
              <th scope="col" className="w-1/2 px-4 py-3.5 text-xs font-semibold uppercase tracking-wide text-slate-400 md:px-6 md:text-sm" data-id="element-232" data-mp="2pgmcznx1ursn">
                Without Functional Fitness 365
              </th>
              <th scope="col" className="w-1/2 border-l border-white/10 px-4 py-3.5 text-xs font-semibold uppercase tracking-wide text-white md:px-6 md:text-sm" data-id="element-233" data-mp="2gjc05y4l2ulm">
                The real cost
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5" data-id="element-234" data-mp="3vds7cw4i36mz">
            {costs.map(row => <tr key={row.sin} data-id="element-235" data-mp="39g4s8kgmxvg">
                <td className="px-4 py-4 text-sm leading-snug text-slate-400 md:px-6 md:text-base" data-id="element-236" data-mp="38olnx81usm2">{row.sin}</td>
                <td className="border-l border-white/10 px-4 py-4 text-sm font-medium leading-snug text-red-400 md:px-6 md:text-base" data-id="element-237" data-mp="3lejgic4xm84u">
                  <span className="inline-flex items-start gap-1.5" data-id="element-238" data-mp="3qg8rxsw2gntg">
                    <ArrowRightIcon size={14} className="mt-0.5 shrink-0 md:mt-1" aria-hidden="true" data-id="element-239" data-mp="3bnyl0xkk1jq5" />
                    {row.costo}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
        </div>

        <p className="mt-8 text-center text-lg font-semibold text-white md:text-xl" data-id="element-240" data-mp="37nembpkc281w">
          Your next workout can be different…
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-slate-950 border-t border-white/5 !pb-28 md:!pb-24" data-id="element-241" data-mp="2e3ylva0reb3s">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-242" data-mp="2e61abpm9jw6e">
        <FadeIn className="text-center lg:text-left" data-id="element-243" data-mp="2a3odxrtepama">
          <h2 className="font-display text-4xl font-black uppercase italic leading-[0.92] tracking-tight text-white md:text-6xl" data-id="element-244" data-mp="2o1uxe2xlz82f">
            You can <Accent data-id="element-245" data-mp="2j29x9p6pcto4">improvise</Accent> your next class — or walk in with everything solved.
          </h2>
          <p className="mt-4 font-display text-3xl font-black uppercase italic text-sky-400 md:text-4xl" data-id="element-246" data-mp="2x19kcsekh0i6">
            Your call.
          </p>

          <div className="mt-8 inline-flex flex-col items-center gap-3 lg:items-start" data-id="element-247" data-mp="36smanfkpvim3">
            <p className="inline-flex items-center gap-2 rounded-full bg-red-500/15 px-3 py-1 text-xs font-bold uppercase tracking-widest text-red-400" data-id="element-248" data-mp="36ugm83a3lydi">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-red-400" aria-hidden="true" data-id="element-249" data-mp="3grlcae72edzl" />
              Last chance · price ends in
            </p>
            <p className="font-display text-5xl font-black tabular-nums leading-none tracking-tight text-white md:text-6xl" role="timer" aria-live="off" data-id="element-250" data-mp="3dxh1yhhdxrdy">
              {pad2(hours)}
              <span className="text-slate-600" data-id="element-251" data-mp="3957er97nn5fd">:</span>
              {pad2(minutes)}
              <span className="text-slate-600" data-id="element-252" data-mp="345uumw864cgh">:</span>
              {pad2(seconds)}
            </p>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-253" data-mp="3049acptb0vw9">
              After that it goes up. It won't come back to this price.
            </p>
          </div>

          <ul className="mt-8 hidden flex-wrap gap-x-6 gap-y-2 text-sm text-slate-400 lg:flex" data-id="element-254" data-mp="3rybffejaiijh">
            <li className="flex items-center gap-2" data-id="element-255" data-mp="3nu3n77dmikgi"><Lock size={14} aria-hidden="true" data-id="element-256" data-mp="3ix3ojhj3sjzf" /> 100% secure payment</li>
            <li className="flex items-center gap-2" data-id="element-257" data-mp="3iz6e60gcgb3m"><Clock size={14} aria-hidden="true" data-id="element-258" data-mp="2ch1h5695hdal" /> Access in 5 minutes</li>
            <li className="flex items-center gap-2" data-id="element-259" data-mp="27hojrrknkntr"><ShieldCheck size={14} aria-hidden="true" data-id="element-260" data-mp="27gn4tc0inh6r" /> 7-day guarantee</li>
            <li className="flex items-center gap-2" data-id="element-261" data-mp="n05vt8ouetht"><CreditCard size={14} aria-hidden="true" data-id="element-262" data-mp="n17aro8zc04t" /> Card · Debit · Local payment in your currency</li>
          </ul>
        </FadeIn>

        <FadeIn delay={0.05} className="mx-auto w-full max-w-md" data-id="element-263" data-mp="w0c66lp8vdcr">
          <OfferCard id="final-offer" footnote="One-time payment · 7-day guarantee included" data-id="element-264" data-mp="vz12smzpo7m6" />
        </FadeIn>

        <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-400 lg:hidden" data-id="element-265" data-mp="10t5cvf49wvrh">
          <li className="flex items-center gap-1.5" data-id="element-266" data-mp="15shwzs3rfoqd"><Lock size={13} aria-hidden="true" data-id="element-267" data-mp="1aofei1qrf14q" /> 100% secure payment</li>
          <li className="flex items-center gap-1.5" data-id="element-268" data-mp="1fobhbxnq0mip"><Clock size={13} aria-hidden="true" data-id="element-269" data-mp="1fpcvib019p4n" /> Access in 5 minutes</li>
          <li className="flex items-center gap-1.5" data-id="element-270" data-mp="1jqeviu1ry57o"><ShieldCheck size={13} aria-hidden="true" data-id="element-271" data-mp="1jpd7zq3knq92" /> 7-day guarantee</li>
          <li className="flex w-full items-center justify-center gap-1.5" data-id="element-272" data-mp="3hgg2mqapslkg"><CreditCard size={13} aria-hidden="true" data-id="element-273" data-mp="3lh9ufura2kim" /> Card · Debit · Local payment in your currency</li>
        </ul>
      </div>
    </Section>;
};
export const Footer = () => <footer className="border-t border-white/5 bg-slate-950 px-5 py-12 md:px-8" data-id="element-274" data-mp="sn1gegbch4vj">
    <div className="mx-auto flex max-w-6xl flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-275" data-mp="np9fwxwmwafq">
      <div className="max-w-sm text-center md:text-left" data-id="element-276" data-mp="11p0y7au6oczj">
        <p className="font-display text-xl font-black uppercase italic tracking-tight text-white" data-id="element-277" data-mp="xlcpupxq9dd8">
          Functional Fitness <Accent data-id="element-278" data-mp="1bklzt7vcbb8r">365™</Accent>
        </p>
        <p className="mt-1 text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-279" data-mp="1bjatp1ef9reh">
          by Center Shop Digital
        </p>
        <p className="mt-4 text-sm leading-relaxed text-slate-400" data-id="element-280" data-mp="1lbyrnzh521es">
          The #1 ready-to-teach class system for functional fitness instructors
          and coaches. Because teaching a great class shouldn't cost you every
          Sunday of the year.
        </p>
      </div>
      <div className="flex flex-col items-center gap-3 text-sm text-slate-400 md:items-end" data-id="element-281" data-mp="1pdbvy54l1wjl">
        <a href="mailto:soportecentershop95@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-282" data-mp="28yu7duyh3so1">
          <MailIcon size={14} aria-hidden="true" data-id="element-283" data-mp="2dwm0uternmuc" /> soportecentershop95@gmail.com
        </a>
        <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-284" data-mp="1zx4862ycnpfp">
          <AtSignIcon size={14} aria-hidden="true" data-id="element-285" data-mp="23y66mhkfzxgm" /> centershop.digital
        </a>
      </div>
    </div>
    <div className="mx-auto mt-10 flex max-w-6xl flex-col items-center gap-3 border-t border-white/5 pt-6 text-xs text-slate-500 md:flex-row md:justify-between" data-id="element-286" data-mp="1q6rpkga3i6c7">
      <p className="text-center md:text-left" data-id="element-287" data-mp="1gaokb1jy5rl1">
        © {new Date().getFullYear()} Center Shop Digital. All rights reserved.
        Prices in US dollars (USD) · Charged in your local currency.
      </p>
      <p className="flex gap-4" data-id="element-288" data-mp="1798cn1kio3ki">
        <a href="#" className="transition-colors duration-150 hover:text-white" data-id="element-289" data-mp="17a9zs4et4gil">Terms &amp; Conditions</a>
        <a href="#" className="transition-colors duration-150 hover:text-white" data-id="element-290" data-mp="1c7rx0xjgp7ar">Privacy Policy</a>
      </p>
    </div>
  </footer>;